import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArFulfillmentEventsCreatedNotifyAuthorProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArFulfillmentEventsCreatedNotifyAuthor: TemplateDefinition<ArFulfillmentEventsCreatedNotifyAuthorProps> =
  {
    renderParams: (props: ArFulfillmentEventsCreatedNotifyAuthorProps) => ({
      messageKey: 'notificationsDomain.templates.arFulfillmentEventsCreatedNotifyAuthor',
      values: {
        eventName: props?.request?.name,
      },
    }),
  }
